import * as stylex from '@stylexjs/stylex';
import { type ReactElement } from 'react';

import { ProgressIndicator, View } from '@/libs/serenity-ui';

export function PendingState (): ReactElement {
  return (
    <View style={styles.base}>
      <ProgressIndicator size={24} variant="primary" />
    </View>
  );
}

const styles = stylex.create({
  base: {
    display: 'flex',
    justifyContent: 'center',
    paddingTop: 80,
  },
});
